module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#comment",
      toString: function () {
        return this.url;
      }
    }